import { EntityStateModel } from 'app/projects/entity/src/lib/models/entity.state-model';
import { Certification } from './certification';

export class CertificationStateModel extends EntityStateModel<Certification> {}
